<template>
  <div class="flex flex-col gap-2 mb-2 h-full">
    <span class="text-start px-2 rounded"> כדי להתחבר צריך את מזהה המשתמש (User Token) של חשבון ה-SmartBee שלכם. פנו לתמיכה של SmartBee וקבלו את ה-User Token המשויך לעסק שלכם.</span>
    <p class="text-sm bg-blue-100 p-4 rounded mt-2">
      <strong>שימו ❤️</strong>
      אם אין לכם עדיין חשבון SmartBee, יש לפתוח חשבון באתר smartbee.co.il ולבקש את ה-User Token.
    </p>

    <div class="w-full mt-auto pt-6">
      <Button
        label="הבא"
        class="w-full "
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

defineEmits(['next']);

</script>

<style scoped lang="scss">

</style>
